var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "banbox" }, [
      _c("div", { staticClass: "efficiency" }),
      _vm._v(" "),
      _c("div", { staticClass: "solve" }, [
        _c(
          "h3",
          { staticStyle: { "font-size": ".14rem", "font-weight": "400" } },
          [_vm._v("易猎云产品")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "solve_box" },
          _vm._l(_vm.solvelist, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "solve_item",
                class: { solve_item_click: _vm.proindex == index },
                on: {
                  click: function($event) {
                    return _vm.proclick(index)
                  }
                }
              },
              [
                _c("img", { attrs: { src: item.icon } }),
                _vm._v(" "),
                _c("h4", [_vm._v(_vm._s(item.title))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(item.text))])
              ]
            )
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "new_advantage" },
      [
        _c(
          "h3",
          { staticStyle: { "font-size": ".14rem", "font-weight": "400" } },
          [_vm._v("易猎云产品优势")]
        ),
        _vm._v(" "),
        _c(
          "van-swipe",
          { attrs: { autoplay: 3000, height: 110 } },
          [
            _c("van-swipe-item", [
              _c("div", { staticClass: "adv_container" }, [
                _c("div", { staticClass: "adv_left" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_grasp the deepening@2x.png"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "adv_right" }, [
                  _c("p", { staticClass: "adv_r_title" }, [_vm._v("领域深耕")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "adv_r_text" }, [
                    _vm._v(
                      "管理团队均出自国内头部人力资源企业，具备10年以上的行业纵深经验，对招聘和外包业务的本质有更深的理解"
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("van-swipe-item", [
              _c("div", { staticClass: "adv_container" }, [
                _c("div", { staticClass: "adv_left" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_technical advantage@2x.png"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "adv_right" }, [
                  _c("p", { staticClass: "adv_r_title" }, [_vm._v("技术优势")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "adv_r_text" }, [
                    _vm._v(
                      "技术人员大部分来自BAT等一线互联网公司及智联招聘、北森等人力资源公司，拥有丰富的大数据、高并发及人力资源系统架构设计经验"
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("van-swipe-item", [
              _c("div", { staticClass: "adv_container" }, [
                _c("div", { staticClass: "adv_left" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_advantage of service@2x.png"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "adv_right" }, [
                  _c("p", { staticClass: "adv_r_title" }, [_vm._v("服务优势")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "adv_r_text" }, [
                    _vm._v(
                      "专属客户成功团队，结合客户业务制定专属培训方案，使用产品的过程中遇到任何问题都能第一时间跟进及解决，保障客户真正的成功"
                    )
                  ])
                ])
              ])
            ])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "new_media" },
      [
        _c(
          "h2",
          { staticStyle: { "font-size": ".14rem", "font-weight": "400" } },
          [_vm._v("媒体报道")]
        ),
        _vm._v(" "),
        _c(
          "van-swipe",
          { attrs: { autoplay: 3000, height: 200 } },
          [
            _c("van-swipe-item", [
              _c("div", { staticClass: "media_swip" }, [
                _c("div", { staticClass: "swip_left" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/pic2_report_02%402x.png"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "swip_title" }, [
                    _vm._v(
                      "RPO数字化趋势下「易猎云」想要为万亿主流市场造一个“工作系统”"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "swip_text" }, [
                    _vm._v(
                      "打通数据平台，支持私域获客，RPO员工效能方可被充分展现。 据国家统计局数据，截止2020年..."
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "swip_bottom" }, [
                    _c("div", { staticClass: "swop_bom_left" }, [
                      _vm._v("2022-05.18")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "swop_bom_right",
                        on: {
                          click: function($event) {
                            return _vm.gotomediamessage("2")
                          }
                        }
                      },
                      [_vm._v("详情 >")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "swip_left" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/pic_report_02%402x.png"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "swip_title" }, [
                    _vm._v("易猎云开创RPO数字化3.0时代,小微企业永久免费")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "swip_text" }, [
                    _vm._v(
                      "近年来，中国作为快速发展的新兴人力资源服务市场，市场规模持续快速增长。根据中智咨询..."
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "swip_bottom" }, [
                    _c("div", { staticClass: "swop_bom_left" }, [
                      _vm._v("2023-05.17")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "swop_bom_right",
                        on: {
                          click: function($event) {
                            return _vm.gotomediamessage("5")
                          }
                        }
                      },
                      [_vm._v("详情 >")]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("van-swipe-item", [
              _c("div", { staticClass: "media_swip" }, [
                _c("div", { staticClass: "swip_left" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/banner3%402x.png"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "swip_title" }, [
                    _vm._v(
                      "易猎云开启RPO3.0时代，人力管理平台是怎样进行数字化转型的？"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "swip_text" }, [
                    _vm._v(
                      "21世纪什么最重要，是人才!2004年，电影《天下无贼》中葛优的一句经典台词，在时隔近20年后的今天..."
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "swip_bottom" }, [
                    _c("div", { staticClass: "swop_bom_left" }, [
                      _vm._v("2022-05.17")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "swop_bom_right",
                        on: {
                          click: function($event) {
                            return _vm.gotomediamessage("1")
                          }
                        }
                      },
                      [_vm._v("详情 >")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "swip_left" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/banner4%402x.png"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "swip_title" }, [
                    _vm._v(
                      "最有前景的RPO数字化趋势来到了，工作系统是怎么逆袭的？"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "swip_text" }, [
                    _vm._v(
                      "打通数据平台、支持私域获客，RPO员工效能被充分展现，易猎云更像是一个..."
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "swip_bottom" }, [
                    _c("div", { staticClass: "swop_bom_left" }, [
                      _vm._v("2022-05.19")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "swop_bom_right",
                        on: {
                          click: function($event) {
                            return _vm.gotomediamessage("3")
                          }
                        }
                      },
                      [_vm._v("详情 >")]
                    )
                  ])
                ])
              ])
            ])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "security" },
      [
        _c(
          "h2",
          { staticStyle: { "font-size": ".14rem", "font-weight": "400" } },
          [_vm._v("安全保障")]
        ),
        _vm._v(" "),
        _c(
          "van-swipe",
          { attrs: { autoplay: 3000, height: 200 } },
          [
            _c("van-swipe-item", [
              _c("div", { staticClass: "sec_swip" }, [
                _c("div", { staticClass: "sec_left" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_safe01%402x.png"
                    }
                  }),
                  _vm._v(" "),
                  _c("h3", [_vm._v("权威认证")]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-top": ".07rem" } }, [
                    _vm._v("ISO9001质量管理体系认证")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("ISO27001信息安全管理体系认证")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sec_left" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_safe02%402x.png"
                    }
                  }),
                  _vm._v(" "),
                  _c("h3", [_vm._v("隐私保护")]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-top": ".07rem" } }, [
                    _vm._v("未经客户授权，不会将数据用做业务外")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("的任何用途，不会将数据转移给第三方")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("van-swipe-item", [
              _c("div", { staticClass: "sec_swip" }, [
                _c("div", { staticClass: "sec_left" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_safe03%402x.png"
                    }
                  }),
                  _vm._v(" "),
                  _c("h3", [_vm._v("安全管控")]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-top": ".07rem" } }, [
                    _vm._v("严格的信息安全管控机制")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("银行级加密通信及阿里云安全支持")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sec_left" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_safe04%402x.png"
                    }
                  }),
                  _vm._v(" "),
                  _c("h3", [_vm._v("应用安全")]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-top": ".07rem" } }, [
                    _vm._v("应用级安全保障数据权限最小必须")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("简历敏感信息加密存储及导出规范")])
                ])
              ])
            ])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("h3", [_vm._v("易猎云招聘管理系统")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "专注于RPO领域的数字化招聘管理系统，主要帮助RPO类企业解决批量招聘的效率、管理、渠道以及内部协同等问题"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "banimg" }, [
        _c("img", {
          attrs: {
            src:
              "https://img.yilieyun.com/oss/ylyh5officialWebimagese/pic_0s2@2x.png"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "advantage" }, [
      _c("div", { staticClass: "adv__enterprise" }, [
        _c("h3", { staticStyle: { "font-weight": "400" } }, [
          _vm._v("与更多优秀企业共同成长")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "adv__box" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "youxiu" }, [
        _c("h3", { staticStyle: { "font-size": ".14rem" } }, [
          _vm._v("合作伙伴")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "youxiu__box" }, [
          _c("div", { staticClass: "youxiu_child1" }, [
            _c("img", {
              attrs: {
                src:
                  "https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_zhilianzhaopin@2x.png"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "youxiu_child2" }, [
            _c("img", {
              attrs: {
                src:
                  "https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_qianchenwuyou@2x.png"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "youxiu__box",
            staticStyle: { "margin-top": ".2rem" }
          },
          [
            _c("div", { staticClass: "youxiu_child1" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/logo_boss%402x.png"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "youxiu_child2" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_58@2x.png"
                }
              })
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98177746", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98177746","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/home/index.vue
// module id = null
// module chunks = 